import { data } from '../../svg/Calendar/data';
import { makeIcon } from '../makeIcon';

export const Calendar = makeIcon(data, 'calendar', 'Calendar');

export default Calendar;
